export const GENDERS = ['male', 'female'] as const;
